import { RuleObject } from 'antd/lib/form';
import React from 'react';

import TranslateText from 'components/hoc/TranslateText';

import { dicCzRegExp, dicIneZemeRegExp } from 'enums/regExp';

import { validateRdc } from './rodneCisloValidation';

/* Ověří, zda zadaná hodnota začíná vzorem */
const _startsWith = (value: string, pattern: string) => {
    let patLen = pattern.length;
    let valueBeginning = value.substring(0, patLen);

    return valueBeginning == pattern;
};

/* Součástí validace DIČ */
const _computeCheckDigit = (vstup: string) => {
    let sum = 0;

    for (let i = 0; i < 7; i++) {
        sum += (vstup.charAt(i).charCodeAt(0) - '0'.charCodeAt(0)) * (8 - i);
    }

    sum %= 11;
    sum = 11 - sum;

    return sum % 10;
};

/* Kontrola ICO (Identifikacni cislo organizace), součástí validace DIČ */
const validateICO = (vstup: string) => {
    // 0 - OK
    // 1 - E: nezadano
    // 2 - E: chybna syntaxe
    // 3 - E: chybna kontrolka

    if (!vstup) return 1; // nezadano
    if (!/^[0-9]{8}$/.test(vstup)) return 2; // chybna syntaxe
    // kontrolni cislice
    const sum = _computeCheckDigit(vstup);
    if (sum !== vstup.charAt(7).charCodeAt(0) - '0'.charCodeAt(0)) return 3; // chybna kontrolka

    return 0;
};

/* Kontrola DIC (Danove identifikacni cislo) */
const validateDIC = (vstupDIC: string) => {
    if (vstupDIC.slice(0, 2) !== 'CZ') {
        // otestuj cizí země
        if (dicIneZemeRegExp.test(vstupDIC)) return 0;
        return 2;
    }

    // 0 - OK
    // 1 - E: nezadano
    // 2 - E: chybna syntaxe
    // 3 - E: chybna kontrolka
    // 4 - E: vadne rodne cislo
    if (!vstupDIC) return 1; // nezadano
    if (!dicCzRegExp.test(vstupDIC)) return 2; // chybna syntaxe

    vstupDIC = vstupDIC.substring(2);

    // kontrola ICO
    if (vstupDIC.length === 8) return validateICO(vstupDIC);

    if (vstupDIC.length === 9 && _startsWith(vstupDIC, '6')) {
        // kontrola VCP (Vlastni cislo platce), resi take skupinove DIC (CZ699...), kontrolni cislice
        vstupDIC = vstupDIC.substring(1);
        const sum = _computeCheckDigit(vstupDIC);

        if (9 - sum !== vstupDIC.charAt(7).charCodeAt(0) - '0'.charCodeAt(0)) return 3; // chybna kontrolka

        return 0;
    }
    // kontrola RC (Rodne cislo)
    const sts = validateRdc(vstupDIC);

    switch (sts) {
        case 1:
        case 2:
            return sts;
        case 3:
        case 4:
        case 5:
            return 4; // vadne rodne cislo
        case 8:
            return 3; // chybna kontrolka
        default:
            break;
    }

    return 0;
};

export const dicValidation = () => [
    () => ({
        validator(_rule: RuleObject, value: string) {
            if (!value || validateDIC(value) === 0) return Promise.resolve();
            return Promise.reject(<TranslateText>NEVALIDNI_DIC</TranslateText>);
        }
    })
];

export default dicValidation;
